
export function SplitCsvLine(line){
    return line.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
}